
// Components
import AccountsPage from './accounts';

// Logic
import AccountLogic from '../../Logic/Account';
import {
	buildFeatureFilterApiParams,
	buildFeatureFilterOptions,
	paginationFromAccountsResponse,
	parseFeatureFilterFromParams,
} from '../../Logic/Account/featureFilter';

// Services
import { Get } from '../../services/ApiRequest';


export default {
    name: 'accounts',
    url: '/accounts/?{page}&{keyword}&{feature_filter_groups}',
    component: AccountsPage,
    resolve: [
        {
            token: 'featureCatalog',
            resolveFn: () => Get('/packages/features', {}),
        },
        {
            token: 'featureOptions',
            deps: ['featureCatalog'],
            resolveFn: (featureCatalog) => buildFeatureFilterOptions(featureCatalog),
        },
        {
            token: 'featureFilter',
            deps: ['$transition$'],
            resolveFn: (trans) => parseFeatureFilterFromParams(trans.params()),
        },
        {
            token: 'data',
            deps: ['$transition$', 'featureFilter'],
            resolveFn: (trans, featureFilter) => {
                let params = {};

                if(trans.params().keyword){
                    params.keyword = decodeURIComponent(trans.params().keyword);
                }

                if(trans.params().page){
                    params.page = trans.params().page;
                }

                Object.assign(params, buildFeatureFilterApiParams(featureFilter));

                // Don't merge into Redux — the list page uses resolve data only
                return AccountLogic.get(false, params);
            }
        },
        {   
            token: 'accounts',
            deps: ['data'],
            resolveFn: (data) => data.data
        },{
            token: 'pagination',
            deps: ['data'],
            resolveFn: (data) => paginationFromAccountsResponse(data),
        },
    ]
};